<template>
  <!-- ##### Search Wrapper Start ##### -->
    <div class="search-wrapper d-flex align-items-center justify-content-center bg-img foo-bg-overlay" style="background-image: url(img/bg-img/bg-2.jpg);">
       <div class="close--icon">
           <i class="fa fa-times"></i>
       </div>
        <!-- Logo -->
        <a href="index.html" class="search-logo"><img src="img/core-img/logo2.png" alt=""></a>
        <!-- Search Form -->
        <div class="search-form">
            <form action="#" method="get">
                <input type="search" name="search" id="search" placeholder="Buscar">
                <button type="submit"><i class="fa fa-search" aria-hidden="true"></i></button>
            </form>
        </div>
        <!-- Copwrite Text -->        
    </div>
    <!-- ##### Search Wrapper End ##### -->
</template>

<script>
export default {

}
</script>

<style>

</style>